package com.kitco.metalynxscrapit.shared.presentation.common

import dev.icerock.moko.resources.ColorResource

data class InputState(
    var value: String = "",
    var background: ColorResource? = null,
    val onChange: (String) -> Unit = {},
)
